import { createSelector } from 'reselect';
import { selectCurrentInstitution } from '../Institutions/selectors';
import { DEFAULT_WHITE_LABEL_ITEM_VISIBILITIES } from '../Portal/constants';
import {
  selectCurrentPortal,
  selectCurrentPortalWhiteLabelItemVisibilities,
  selectCurrentPortalWhiteLabelItemVisibilityRoleSetting,
} from '../Portal/selectors';
import {
  WhiteLabelItemVisibilityRoleSetting,
  WhiteLabelVisibilitySettingNames,
} from '../Portal/types';
import { ReduxState } from '../state';
import { currentUserSelector } from '../Users/selectors';
import { TopbarExpandedMenu, TopbarDropdownAlignment } from './constants';
import { TopbarState } from './state';

const TopBarSelector = (state: ReduxState): TopbarState => state.TopBar;

export const selectTopBarExpandedMenu = createSelector(
  TopBarSelector,
  (topBar): TopbarExpandedMenu | null => {
    return topBar.expandedMenu;
  }
);

export const selectTopBarIsMenuTriggeredClick = createSelector(
  TopBarSelector,
  (topBar): boolean => {
    return topBar.isMenuTriggeredClick;
  }
);

export const selectTopBarExpandedMenuAlignment = createSelector(
  TopBarSelector,
  (topBar): TopbarDropdownAlignment => {
    return topBar.expandedMenuAlignment;
  }
);

export const selectTopBarSiteNavRendered = createSelector(
  TopBarSelector,
  (topBar): boolean => {
    return topBar.siteNavRendered;
  }
);

export const selectTopBarItemVisibilities = createSelector(
  currentUserSelector,
  selectCurrentInstitution,
  selectCurrentPortal,
  selectCurrentPortalWhiteLabelItemVisibilities,
  selectCurrentPortalWhiteLabelItemVisibilityRoleSetting,
  (
    user,
    institution,
    portal,
    itemVisibilities,
    itemVisibilityRoleSetting
  ): Record<WhiteLabelVisibilitySettingNames, boolean> => {
    if (!institution || !portal) return DEFAULT_WHITE_LABEL_ITEM_VISIBILITIES;

    const isUserInstitutionAdmin = institution
      .get('admins', [])
      .includes(user?.get('profileName'));

    if (
      isUserInstitutionAdmin &&
      itemVisibilityRoleSetting ===
        WhiteLabelItemVisibilityRoleSetting.showAllForAdmin
    ) {
      return DEFAULT_WHITE_LABEL_ITEM_VISIBILITIES;
    }

    return {
      ...DEFAULT_WHITE_LABEL_ITEM_VISIBILITIES,
      ...(itemVisibilities?.toJS() || {}),
    };
  }
);
